import { Link } from "react-router-dom";

interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  to?: string;
  moreLabel?: string;
  align?: "left" | "center";
}

export default function SectionTitle({
  eyebrow,
  title,
  subtitle,
  to,
  moreLabel = "查看更多",
  align = "left",
}: SectionTitleProps) {
  return (
    <div
      className={`mb-6 flex flex-col gap-3 sm:flex-row sm:items-end ${
        align === "center" ? "items-center text-center" : "items-start"
      }`}
    >
      <div className={align === "center" ? "mx-auto" : ""}>
        {eyebrow && (
          <span className="text-xs font-medium uppercase tracking-wider text-primary-600">{eyebrow}</span>
        )}
        <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">{title}</h2>
        {subtitle && <p className="mt-2 max-w-2xl text-sm text-foreground-600">{subtitle}</p>}
      </div>
      {to && (
        <Link
          to={to}
          className="group flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700 sm:ml-auto"
        >
          {moreLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}